import { useIsCustomColorTheme } from "@circle-react/hooks/useIsCustomColorTheme";
import { THEME_MAP, useThemeContext } from "@circle-react/providers/Theme";
import { colord } from "colord";

const headerBackgroundCssVar = "--color-community-header-background";

const useHeaderColor = () => {
  const { customColors, isCustomTheme, currentTheme, currentAppearance } =
    useThemeContext();
  const customHeaderColor =
    customColors[currentAppearance]?.header_background_color || "#fff";

  const themeHeaderColor =
    THEME_MAP[currentTheme as keyof typeof THEME_MAP]?.[currentAppearance]?.[
      headerBackgroundCssVar
    ] || "#fff";

  return isCustomTheme ? colord(customHeaderColor) : colord(themeHeaderColor);
};

export const useCustomHeaderBorderColor = () => {
  const headerColor = useHeaderColor();

  if (headerColor.isDark()) {
    return headerColor.lighten(0.1).toHex();
  }
  return headerColor.darken(0.1).toHex();
};

export const useHeaderBorderStyles = () => {
  const borderColor = useCustomHeaderBorderColor();
  const isCustomColorTheme = useIsCustomColorTheme();

  if (isCustomColorTheme) {
    return {
      borderColor,
    };
  }
  return {};
};
